import { collectionRequestURL, isCollectionURL } from './collection-availability.js';
import { sectionRenderer } from '@theme/section-renderer';

async function refreshAvailability() {
  const list = document.querySelector('collection-component results-list');
  if (!list || !isCollectionURL() || Shopify.designMode) {
    document.documentElement.classList.remove('cop-stock-loading');
    return;
  }
  list.setAttribute('aria-busy', 'true');
  try {
    await sectionRenderer.renderSection(list.getAttribute('section-id'), { cache: false, url: collectionRequestURL() });
    document.dispatchEvent(new Event('cop:availability-rendered'));
  } catch (error) {
    console.error('Collection availability could not be loaded', error);
    const notice = document.createElement('p');
    notice.setAttribute('role', 'status');
    notice.textContent = 'Availability could not be applied. Please refresh to try again.';
    list.prepend(notice);
  } finally {
    document.querySelector('collection-component results-list')?.removeAttribute('aria-busy');
    document.documentElement.classList.remove('cop-stock-loading');
  }
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refreshAvailability, { once: true });
else refreshAvailability();
window.addEventListener('popstate', refreshAvailability);
